import { Comment } from "./Comment";
import { CommentForm } from "./CommentForm";
import { CommentList } from "./CommentList";
import { CommentPagination } from "./CommentPagination";

export const Comments = {
  Item: Comment,
  Form: CommentForm,
  List: CommentList,
  Pagination: CommentPagination,
};

export { EntityComments } from "./EntityComments";
export { DeleteCommentConfirmation } from "./DeleteCommentConfirmation";
